import { defineCustomElement } from 'vue';
import AxCardPaymentComponent from './AxCardPayment.ce.vue';
import type { AxCardPaymentElement } from './types';

export type { AxCardPaymentElement, AxCardPaymentEventMap } from './types';

export const AxCardPayment = defineCustomElement(AxCardPaymentComponent);

export const TAG_NAME = 'ax-card-payment';

export function register(tagName: string = TAG_NAME): void {
  if (!customElements.get(tagName)) {
    customElements.define(tagName, AxCardPayment);
  }
}

// Auto-register so `<script src>` + `<ax-card-payment>` works with no extra code.
if (typeof window !== 'undefined' && 'customElements' in window) {
  register();
}

declare global {
  interface HTMLElementTagNameMap {
    'ax-card-payment': AxCardPaymentElement;
  }
}
